import useSWRMutation from "swr/mutation";
import useSWRImmutable from "swr/immutable";
import useSWR, { SWRResponse } from "swr";
import { getFetcher, postFetcher } from "./fetchers";
import { QuoteDetailsResponse, QuotePriceResponse } from "./types";

export function usePostKyc(options = {}) {
  const res = useSWRMutation(
    "/api/health-insurance-plan/customer-kyc",
    postFetcher,
    options
  );
  return res;
}

export function useGetUserIP(options = {}): SWRResponse<{ ip: string }, any> {
  const res = useSWR("https://api.ipify.org/?format=json", getFetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    ...options,
  });
  return res;
}

export function useGetCities({
  url = "/api/cities",
  options = {},
}): SWRResponse<any, any> {
  const res = useSWRImmutable(url, getFetcher, {
    ...options,
  });
  return res;
}

export function usePostQuote(options = {}) {
  const res = useSWRMutation(
    "/api/health-insurance-plan/quote",
    postFetcher,
    options
  );
  return res;
}

export function useGetQuoteDetails({
  url = "/api/health-insurance-plan/quote",
  options = {},
  quoteId,
}): SWRResponse<QuoteDetailsResponse, any> {
  const res = useSWRImmutable(
    quoteId ? url + "?" + `quoteId=${quoteId}` : null,
    getFetcher,
    {
      ...options,
      revalidateOnMount: true,
    }
  );
  return res;
}

export function useGetQuotePrice({
  url = "/api/health-insurance-plan/quote/price",
  options = {},
  queryParams = {},
  shouldFetch=false
}): SWRResponse<QuotePriceResponse, any> {
  const query = new URLSearchParams(queryParams);
  const res = useSWRImmutable(
    !shouldFetch||Object.values(queryParams).some((val) => val === undefined)
      ? null
      : url + "?" + query,
    getFetcher,
    {
      ...options,
    }
  );
  return res;
}

export function useGenerateOTP(options = {}) {
  const res = useSWRMutation("/api/otp/staff/generate", postFetcher, options);
  return res;
}

export function useValidateOTP(options = {}) {
  const res = useSWRMutation("/api/otp/staff/validate", postFetcher, options);
  return res;
}

export function usePhoneGenerateOTP(options = {}) {
  const res = useSWRMutation("/api/otp/phone/generate", postFetcher, options);
  return res;
}

export function usePhoneValidateOTP(options = {}) {
  const res = useSWRMutation("/api/otp/phone/validate", postFetcher, options);
  return res;
}

export function usePurchasePlan(options = {}) {
  const res = useSWRMutation(
    "/api/QuoteToAppformService/getRedirectionLink",
    postFetcher,
    options
  );
  return res;
}

export function useDeleteApplicationFormDetails(options = {}) {
  const res = useSWRMutation(
    "/api/health-insurance-plan/application-form",
    postFetcher,
    options
  );
  return res;
}
export function useSkipPost(options = {}) {
  const res = useSWRMutation(
    "/api/signzy/getData",
    postFetcher,
    options
  );
  return res;
}
export function useValidateCorporatePlanOtp(options ={}){
    const res =useSWRMutation("/api/otp-service/validate" , postFetcher , options);
    return res
}

export function useGenerateCorporatePlanOtp(options ={}){
    const res =useSWRMutation("/api/otp-service/generate" , postFetcher , options);
    return res;
}

